import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Grid,
  makeStyles,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CreateIcon from '@material-ui/icons/Create';
import ShowFiles from '../updateGrRecord/ShowFiles';
import DropFilesAttach from '../models/files/DropFilesAttach';
import PoTableQaApproval from '../supplierPOApprove/PoTableQaApproval';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';
import OtherInfo from './OtherInfo';
import StyledButton from '../models/Button';
import { StyledCheckbox } from '../../../../common/models/CheckBox';
import { updateGRN } from '../../../containers/actions/cmo/shortFallsActions';
import CustomDatePickerMui from '../models/inputs/DateInput';
import { SupplierPOContext } from '../grnReceipts/context';
import BackDropLoading from '../models/BackDrop';
import { RejectionRemarks } from '../models/dialogs/CommonDialogs';
import { useDispatch, useSelector } from 'react-redux';
import StyledDialog from '../../../../common/models/Dialog';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },

  orangeButton: {
    backgroundColor: '#F26B38',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 25,
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#d55b2e',
    },
  },
  whiteButton: {
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #999',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 25,
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#000',
      color: '#fff',
    },
  },
  dialogContent: {
    textAlign: 'center',
    padding: '40px 60px',
  },
  checkIcon: {
    color: 'green',
    fontSize: 60,
    marginBottom: 20,
  },
  okButton: {
    backgroundColor: '#F26B38',
    color: '#fff',
    textTransform: 'none',
    borderRadius: 25,
    padding: '6px 25px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#d55b2e',
    },
  },
  required: {
    color: 'red',
  },
}));

const Review = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    onClose,
    qaInfoData,
    poDetails,
    // COAFiles,
    // fileHandling,
    // handlingDeleteFile,
    tempNumber,
    errors,
    handleValidation,
    setErrors,
  } = props;
  const updateGRNData = useSelector(
    (state) => state.pcmp.cmo.shortFalls.updateGRNData
  );
  const ref = useRef(null);

  const { fetchGRLineItems } = useContext(SupplierPOContext);
  const [data, setData] = useState(qaInfoData);

  const [editData, setEditData] = useState(qaInfoData); // temp storage for edits
  const [isEditing, setIsEditing] = useState(false);
  const [editOtherInfo, setEditOtherInfo] = useState(false);
  const [OtherInfoTempNumber, setOtherInfoTempNumber] = useState(tempNumber);
  const [verifyConsent, setVerifyConsent] = useState(false);
  const [rejectionRemarksOpen, setRejectionRemarksOpen] = useState(false);
  const [submitRecord, setsubmitRecord] = useState(false);

  // const handleClose = () => {
  //   onClose();
  // };

  const handleSendForApproval = () => {
    if (verifyConsent && parseFloat(data.rejectedQuantityQA) > 0) {
      setRejectionRemarksOpen(true);
    } else if (verifyConsent) {
      handleSubmitRecord('submit');
    } else {
      setErrors({ ...errors, verifyConsent: true });
    }
  };

  const handleSave = (type) => {
    if (type === 'OtherInfo') {
      setData((previousData) => ({
        ...previousData,
        otherInformation: editData.otherInformation,
        otherFiles: editData.otherFiles,
      }));
      setEditOtherInfo(false);
    } else if (type === 'QaInfo') {
      if (handleValidation(editData)) {
        setData((previousData) => ({
          ...previousData,
          analyticalReportNumber: editData.analyticalReportNumber,
          samplingQuantityQA: editData.samplingQuantityQA,
          cmoQADate: editData?.cmoQADate,
          samplingMaterialNumberQA: editData?.samplingMaterialNumberQA,
          passedQtyQA: editData?.passedQtyQA,
          rejectedQuantityQA: editData?.rejectedQuantityQA,
          COAFiles: editData.COAFiles,
        })); // update data with edited values
        setIsEditing(false);
      }
    } else {
    }
  };

  const handleCancel = (type) => {
    if (type === 'OtherInfo') {
      setEditData((previousData) => ({
        ...previousData,
        otherInformation: data.otherInformation,
        otherFiles: data.otherFiles,
      }));
      setEditOtherInfo(false);
    } else if (type === 'QaInfo') {
      setEditData((previousData) => ({
        ...previousData,
        analyticalReportNumber: data.analyticalReportNumber,
        samplingQuantityQA: data.samplingQuantityQA,
        cmoQADate: data?.cmoQADate,
        samplingMaterialNumberQA: data?.samplingMaterialNumberQA,
        passedQtyQA: data?.passedQtyQA,
        rejectedQuantityQA: data?.rejectedQuantityQA,
        COAFiles: data.COAFiles,
      })); // update data with edited values
      setIsEditing(false);
    } else {
    }
  };

  const fileHandling = (files, Type) => {
    files.forEach((file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: file.name,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };

        // setCOAFILES([...COAFiles, newArr]);
        setEditData((previousData) => ({
          ...previousData,
          COAFiles: [...previousData.COAFiles, newArr],
        }));
        // handlingFiles(newArr, 'COAFiles');
      };
    });
  };

  const handlingDeleteFile = (i) => {
    // for rec fromBE=> mfd as 1, for local filter out
    //check for filetype in file
    //if 'buffer' then follow filter logic
    // if it is not buffer edit that file data sayn mfd 1
    if (editData.COAFiles[i].grFileType === 'buffer') {
      let newdel = editData.COAFiles.filter(
        (file) => file.grFileName !== editData.COAFiles[i].grFileName
      );
      setEditData((previousData) => ({ ...previousData, COAFiles: newdel }));
      // setCOAFILES(newdel);
    } else {
      // COAFiles[i].markForDelete=1;
      let markDelFile = editData.COAFiles.map((file) =>
        file.grFileHash === editData.COAFiles[i].grFileHash
          ? { ...file, markForDelete: true }
          : file
      );
      setEditData((previousData) => ({
        ...previousData,
        COAFiles: markDelFile,
      }));
      // setCOAFILES(markDelFile);
    }
  };

  const handlingDeleteFileType = (i, name) => {
    if (name === 'COAFiles') {
      if (editData.COAFiles[i].grFileType === 'buffer') {
        let newdel = editData.COAFiles.filter(
          (file) => file.grFileName !== editData.COAFiles[i].grFileName
        );
        // this.setState({
        //   qualityAssuranceInfo: {
        //     ...this.state.qualityAssuranceInfo,
        //     COAFiles: newdel,
        //     deletePrompt: false,
        //   },
        // });
        setEditData((previousData) => ({
          ...previousData,
          COAFiles: newdel,
        }));
      }
    }

    //invoice files deleting in Parent File
    if (name === 'otherFiles') {
      if (editData.otherFiles[i].grFileType === 'buffer') {
        let newdel = editData.otherFiles.filter(
          (file) => file.grFileName !== editData.otherFiles[i].grFileName
        );
        setEditData((previousData) => ({
          ...previousData,
          otherFiles: newdel,
          deletePrompt: false,
        }));
      }
    }
  };

  const handlingFiles = (file, name) => {
    console.log(name === 'otherFiles');
    console.log(file);
    if (name === 'COAFiles') {
      setEditData((previousData) => ({
        ...previousData,
        COAFiles: [...previousData.COAFiles, file],
      }));
    }
    if (name === 'otherFiles') {
      setEditData((previousData) => ({
        ...previousData,
        otherFiles: previousData?.otherFiles
          ? [...previousData.otherFiles, file]
          : [file],
      }));
    }
  };

  const handleTempNumber = (name) => {
    console.log(name === 'OtherInfoTempNumber');
    console.log(OtherInfoTempNumber + 1);
    if (name === 'OtherInfoTempNumber') {
      setOtherInfoTempNumber(OtherInfoTempNumber + 1);
    }
  };

  const handleChange = (e, name) => {
    console.log(name === 'otherInformation');
    console.log(e.target.value);
    if (name === 'otherInformation') {
      let { value } = e.target;

      setEditData((previousData) => ({
        ...previousData,
        otherInformation: value,
      }));
    }
  };

  const handleVerifyConsent = () => {
    setVerifyConsent(!verifyConsent);
    if (!verifyConsent) {
      setErrors({ ...errors, verifyConsent: false });
    }
  };

  const handleSubmitRecord = (type) => {
    console.log('In submit');
    setRejectionRemarksOpen(false);
    let backdropText = 'Please Wait. Sending for approval ....';

    let reqObj = {
      PODetails: {
        ...poDetails,
        GRDetails: {
          ...poDetails.GRDetails,
          POBatchRecordDetails: {
            ...poDetails.GRDetails.POBatchRecordDetails,
            isSubmitForApproval: type === 'submit' ? true : false,
          },
          qualityAssuranceInfo: {
            ...poDetails.GRDetails.qualityAssuranceInfo,
            ...data,
            cmoQADate: data.cmoQADate
              ? moment.utc(data.cmoQADate).format('YYYY-MM-DDTHH:mm:ss[Z]')
              : null,
            samplingQuantityQA: data.samplingQuantityQA
              ? parseFloat(data.samplingQuantityQA)
              : 0,
            passedQtyQA: data.passedQtyQA ? parseFloat(data.passedQtyQA) : 0,
            rejectedQuantityQA: data.rejectedQuantityQA
              ? parseFloat(data.rejectedQuantityQA)
              : 0,
          },
        },
      },
    };
    if (type === 'submit') {
      backdropText = 'Please Wait. Record is being submitted for approval';

      // let isError = this.validate();
      // if (!isError && this.state.verifyConsent === false) {
      //   this.setState({
      //     errors: {
      //       verifyConsent: true,
      //     },
      //     addRecord: false,
      //   });
      // } else if (!isError && verifyConsent) {
      //   updateGRN(reqObj, backdropText);
      // }
      if (verifyConsent) {
        // console.log(reqObj);
        // setRejectionRemarksOpen(false);
        // setsubmitRecord(true);
        ref.current = 1;
        dispatch(updateGRN(reqObj, backdropText));
      }
    } else {
      // console.log(reqObj);
      setRejectionRemarksOpen(false);
      dispatch(updateGRN(reqObj, backdropText));
    }
  };

  const handleCloseRecord = () => {
    setsubmitRecord(false);
    fetchGRLineItems();
    onClose();
  };

  useEffect(() => {
    if (updateGRNData?.status === false && ref.current === 1) {
      ref.current = null;
      const errorKey = Object.keys(updateGRNData.errorDescription || {})[0];
      if (errorKey) {
        // setState((prev) => ({
        //   ...prev,
        //   resError: updateGRNData.errorDescription[errorKey],
        //   errors: { [errorKey]: true },
        //   deleteLoading: false,
        // }));
        setErrors({
          ...errors,
          errorTitle: updateGRNData.errorDescription[errorKey],
        });
      } else {
        setErrors({
          ...errors,
          errorTitle: 'Something went wrong. Please try again.',
        });
      }
    } else if (updateGRNData?.status === true && ref.current === 1) {
      ref.current = null;
      setsubmitRecord(true);
    }
  }, [updateGRNData]);

  return (
    <React.Fragment>
      <BackDropLoading />
      <PoTableQaApproval
        POLineRecordDetails={poDetails?.POLineRecordDetails}
        POBatchRecordDetails={poDetails?.GRDetails?.POBatchRecordDetails}
        receivedQuantityInfo={poDetails?.GRDetails?.receivedQuantityInfo}
        ansDetails={poDetails?.GRDetails?.asnDetails}
        qualityAssuranceInfo={poDetails?.GRDetails?.qualityAssuranceInfo}
      />
      <Grid container justifyContent='center'>
        <Grid item xs={12} sm={6} md={10}>
          <Grid container justifyContent='center'>
            {errors?.errorTitle && (
              <Grid
                container
                justifyContent='center'
                style={{ padding: '1rem 0' }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    variant='h6'
                    style={{
                      border: '1px solid #FF0000',
                      backgroundColor: '#FFF0F0',
                      opacity: '1',
                      textAlign: 'center',
                      padding: '0.8rem',
                      fontSize: '0.875rem',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {errors?.errorTitle}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={6} md={6} className={classes.grid}>
              <Typography variant='h4' className={classes.title}>
                {/* Quality Assurance Information */}
                Material Inspection Information
              </Typography>
              <span className={classes.borders}></span>
            </Grid>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
              className={classes.grid}
              item
              xs={12}
              sm={6}
            >
              {isEditing ? (
                <div>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => handleSave('QaInfo')}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </Button>
                  <Button
                    variant='outlined'
                    onClick={() => handleCancel('QaInfo')}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    variant='contained'
                    startIcon={<CreateIcon fontSize='small' />}
                    style={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      border: '1px solid #000000de',
                    }}
                    size='small'
                    onClick={() => setIsEditing(true)}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Analytical Report (AR) Number{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {isEditing ? (
                // <TextField
                //   fullWidth
                //   size='small'
                //   variant='outlined'
                //   className={classes.textfieldWidth}
                //   placeholder='Enter Analytical Report Number'
                //   value={editData?.cmoAnalyticalReportNumber || ''}
                //   onChange={(e) =>
                //     setEditData((previousData) => ({
                //       ...previousData,
                //       cmoAnalyticalReportNumber: e.target.value,
                //     }))
                //   }
                // />
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  placeholder='Enter Analytical Report Number'
                  value={editData?.analyticalReportNumber || ''}
                  onChange={(e) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      analyticalReportNumber: e.target.value,
                    }))
                  }
                />
              ) : (
                <Typography>
                  {presentFormatedData(data.analyticalReportNumber, 'NA')}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Unit of Measurement (UOM){' '}
                {/* <span className={classes.required}>*</span> */}
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  // value={editData.unitOfMeasurementQA}
                  value={
                    poDetails?.POLineRecordDetails.unitOfMeasurementOrdered
                  }
                />
              ) : (
                <Typography>
                  {/* {presentFormatedData(editData.unitOfMeasurementQA, '-')} */}
                  {presentFormatedData(
                    poDetails?.POLineRecordDetails.unitOfMeasurementOrdered,
                    '-'
                  )}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Quantity used for Sampling{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  value={editData.samplingQuantityQA}
                  onChange={(e) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      samplingQuantityQA:
                        e.target.value === '' ? '0' : e.target.value,
                    }))
                  }
                  error={!!errors?.qaQuantityFields}
                  helperText={errors.qaQuantityFields}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                  }}
                />
              ) : (
                <Typography>
                  {presentFormatedData(data.samplingQuantityQA, '0')}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Enter CMO Inspection Date{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {isEditing ? (
                // <TextField
                //   fullWidth
                //   type='date'
                //   size='small'
                //   variant='outlined'
                //   className={classes.textfieldWidth}
                //   value={editData?.cmoQADate || ''}
                //   onChange={(e) =>
                //     setEditData((previousData) => ({
                //       ...previousData,
                //       cmoQADate: e.target.value,
                //     }))
                //   }
                //   error={!!errors.cmoQADate}
                //   helperText={errors.cmoQADate}
                // />
                <CustomDatePickerMui
                  name='cmoQADate'
                  value={editData?.cmoQADate || null}
                  error={!!errors.cmoQADate}
                  onChange={(date) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      cmoQADate: date,
                    }))
                  }
                  helperText={errors.cmoQADate}
                  FullWidth
                />
              ) : (
                <Typography>
                  {data.cmoQADate
                    ? presentFormatedData(
                        new Date(data.cmoQADate)
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/ /g, '-'),
                        'NA'
                      )
                    : 'NA'}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                CMO Sampling Material Number
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  value={editData?.samplingMaterialNumberQA || ''}
                  onChange={(e) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      samplingMaterialNumberQA: e.target.value,
                    }))
                  }
                />
              ) : (
                <Typography>
                  {presentFormatedData(data.samplingMaterialNumberQA, 'NA')}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Material Passed Quantity{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  value={editData?.passedQtyQA}
                  onChange={(e) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      passedQtyQA: e.target.value === '' ? 0 : e.target.value,
                    }))
                  }
                  error={!!errors?.qaQuantityFields}
                  helperText={errors.qaQuantityFields}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                  }}
                />
              ) : (
                <Typography>
                  {presentFormatedData(data.passedQtyQA, '0')}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Material Rejected Quantity{' '}
                <span className={classes.required}>*</span>
              </Typography>
              {isEditing ? (
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  className={classes.textfieldWidth}
                  value={editData?.rejectedQuantityQA}
                  onChange={(e) =>
                    setEditData((previousData) => ({
                      ...previousData,
                      rejectedQuantityQA:
                        e.target.value === '' ? 0 : e.target.value,
                    }))
                  }
                  error={!!errors?.qaQuantityFields}
                  helperText={errors.qaQuantityFields}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                  }}
                />
              ) : (
                <Typography>
                  {presentFormatedData(data.rejectedQuantityQA, '0')}
                </Typography>
              )}
            </Grid>
            {isEditing && (
              <Grid item xs={12} sm={12} className={classes.grid}>
                <DropFilesAttach
                  title='Upload Certificates of Analysis (CoA/CoC)'
                  handleUploadFiles={fileHandling}
                  required={false}
                />
              </Grid>
            )}

            <Grid
              container
              className={classes.padding}
              style={{ paddingBottom: '1rem' }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography
                  variant='body2'
                  className={classes.font}
                  style={{ paddingBottom: '0.5rem' }}
                >
                  Uploaded Document List
                </Typography>

                <ShowFiles
                  files={isEditing ? editData.COAFiles : data.COAFiles}
                  handlingDeleteFile={handlingDeleteFile}
                  name='COAFiles'
                  isUploadFile={isEditing}
                  filesRequired={errors.coaFile}
                  // filesRequired={QAValidations.coaFile?.required}
                />
              </Grid>
            </Grid>
          </Grid>

          <hr />
          <Grid container>
            <Grid item xs={12} sm={6} md={6} className={classes.grid}>
              <Typography variant='h4' className={classes.title}>
                Other Information
              </Typography>
              <span className={classes.borders}></span>
            </Grid>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
              className={classes.grid}
              item
              xs={12}
              sm={6}
            >
              {editOtherInfo ? (
                <div>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => handleSave('OtherInfo')}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </Button>
                  <Button
                    variant='outlined'
                    onClick={() => handleCancel('OtherInfo')}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    variant='contained'
                    startIcon={<CreateIcon fontSize='small' />}
                    style={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      border: '1px solid #000000de',
                    }}
                    size='small'
                    onClick={() => setEditOtherInfo(true)}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Grid>
            <OtherInfo
              isAddRecord={editOtherInfo}
              qaInfoData={editData}
              handleChange={handleChange}
              handlingFiles={handlingFiles}
              //parent
              parentHandlingDeleteFile={handlingDeleteFileType}
              //appending file
              OtherInfoTempNumber={OtherInfoTempNumber}
              handleTempNumber={handleTempNumber}
            />
            {/* {editOtherInfo ? (
              <OtherInfo
                isAddRecord={false}
                qaInfoData={editData}
                handleChange={handleChange}
                handlingFiles={handlingFiles}
                //parent
                parentHandlingDeleteFile={handlingDeleteFileType}
                //appending file
                OtherInfoTempNumber={OtherInfoTempNumber}
                handleTempNumber={handleTempNumber}
              />
            ) : (
              <OtherInfo
                isAddRecord={false}
                qaInfoData={data}
                handleChange={handleChange}
                handlingFiles={handlingFiles}
                //parent
                parentHandlingDeleteFile={handlingDeleteFileType}
                //appending file
                OtherInfoTempNumber={OtherInfoTempNumber}
                handleTempNumber={handleTempNumber}
              />
            )} */}
          </Grid>

          <Grid
            container
            // className={classes.grid}
            style={{
              border:
                errors.verifyConsent === true
                  ? '0.5px solid red'
                  : '0.5px solid #707070',
              padding: '1rem',
            }}
          >
            <FormControlLabel
              control={
                <StyledCheckbox
                  checked={verifyConsent}
                  onClick={handleVerifyConsent}
                  // color={errors.verifyConsent === true ? 'red' : 'default'}
                />
              }
              color={errors.verifyConsent && 'error'}
              label={
                <Typography variant='body1'>
                  I verify that all the details in this record have been
                  verified and checked.
                </Typography>
              }
            />
          </Grid>
          <div className={classes.error}>
            {errors.verifyConsent && (
              <Typography variant='body2' color='error'>
                Please Verify that Entered Data is Correct
              </Typography>
            )}
          </div>

          <Grid container justifyContent='center' style={{ padding: '3rem 0' }}>
            <StyledButton onClick={handleSendForApproval}>
              Submit for Approval
              {/* submit for Acknowledgement */}
            </StyledButton>
            {/* <StyledButton
              className={classes.rejectOrIncompleteButton}
              onClick={() => handleSubmitRecord()}
            >
              Record Incomplete,Save record
            </StyledButton> */}
          </Grid>
        </Grid>
      </Grid>

      <RejectionRemarks
        open={rejectionRemarksOpen}
        title={'Record Sending for Approval'}
        // textLabel={
        //   this.state.POBatchRecordDetails.batchStatusID === 3 ||
        //   this.state.action === 'reject'
        //     ? 'Add remarks for rejection'
        //     : 'Add remarks for repeating QC/QA'
        // }
        subtitle={'Add remarks for rejection (optional)'}
        helperText={'Reason for rejected quantity'}
        handleAddReason={() => handleSubmitRecord('submit')}
        onClose={() => {
          setRejectionRemarksOpen(false);
          setData((previousData) => ({
            ...previousData,
            reasonForRejection: '',
          }));
        }}
        onTextChange={(e) =>
          setData((previousData) => ({
            ...previousData,
            reasonForRejection: e.target.value,
          }))
        }
        textValue={data.reasonForRejection}
        // disabled={this.state.disableButtons.recordRejected}
      />

      <Dialog open={submitRecord} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseRecord}
          title='The Record has been submitted'
          //subtitle='Your Record has been added and sent for approval.Please Contact the Admin if you have Entered the Wrong Data.'
        />
      </Dialog>

      {/* 
        <Dialog open={open} onClose={handleClose}>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.checkIcon} />
            <Typography variant='h6' style={{ fontWeight: 600 }}>
              The Record has been Saved
            </Typography>
            <div style={{ marginTop: 30 }}>
              <Button className={classes.okButton} onClick={handleClose}>
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog open={submitDialog} onClose={handleClose}>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.checkIcon} />
            <Typography variant='h6' style={{ fontWeight: 600 }}>
              The Record has been Submitted
            </Typography>
            <div style={{ marginTop: 30 }}>
              <Button className={classes.okButton} onClick={handleClose}>
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>
        */}
    </React.Fragment>
  );
};

export default Review;
